<div class="event-notification" [ngClass]="{ 'event-notification_pending-changes': hasPendingChanges() }">
  <div class="d-flex justify-content-between align-items-center">
    <span class="d-flex align-items-center cursor-pointer w-100" (click)="toggleOpenCloseState()">
      <mat-icon class="cursor-pointer header-icon" [svgIcon]="isOpenState ? 'arrow-down' : 'arrow-right'" />

      <span class="me-auto ms-2 text-truncate fw-bold notification-title w-100">
        <ng-content select="[notificationTitle]" />
      </span>
    </span>
    @if (!disabled()) {
    <mat-icon class="cursor-pointer editor-trash-icon ms-auto header-icon" svgIcon="trash"
      [matTooltip]="'STUDY.EVENTS.NOTIFICATIONS.REMOVE' | translate" (click)="deleteNotification()" />
    }
  </div>

  @if (isOpenState) {
  <form class="d-flex flex-column gap-16 my-16" [formGroup]="form">
    <div>
      <phar-form-field label="STUDY.EVENTS.NOTIFICATIONS.WHEN" [isRequired]="true">
        <ng-container inputField>
          <p-select formControlName="timing" optionLabel="label" class="w-100" appendTo="body" optionValue="value"
            [options]="timingOptions" [placeholder]="'STUDY.EVENTS.NOTIFICATIONS.SELECT_WHEN' | translate">
            <ng-template #selectedItem let-selectedOption>
              {{ selectedOption.label | translate }}
            </ng-template>
            <ng-template #item let-option>
              {{ option.label | translate }}
            </ng-template>
          </p-select>
        </ng-container>
        <phar-validators validators [control]="form.get('timing')" [errors]="[
              {
                type: 'required',
                message: 'STUDY.EVENTS.NOTIFICATIONS.ERRORS.WHEN_REQUIRED',
              },
            ]" />
      </phar-form-field>
    </div>

    @if (timingControlValue() !== TimingOptions.During) {
    <div class="row gx-0">
      <div class="col-6 pe-1">
        <phar-form-field label="STUDY.EVENTS.NOTIFICATIONS.QUANTITY" [isRequired]="true">
          <input inputField class="input" type="number" formControlName="number"
            [placeholder]="'STUDY.EVENTS.NOTIFICATIONS.QUANTITY' | translate" />
          <phar-validators validators [control]="form.get('number')"
            [errors]="[{ type: 'required', message: 'STUDY.EVENTS.NOTIFICATIONS.ERRORS.QUANTITY_REQUIRED' }]" />
        </phar-form-field>
      </div>

      <div class="col-6 ps-1">
        <phar-form-field label="STUDY.EVENTS.NOTIFICATIONS.UNIT" [isRequired]="true">
          <ng-container inputField>
            <p-select formControlName="unit" optionLabel="label" class="w-100" appendTo="body" optionValue="value"
              [options]="timeUnitDisplayOptions" [placeholder]="'STUDY.EVENTS.NOTIFICATIONS.UNIT' | translate">
              <ng-template #selectedItem let-selectedOption>
                {{ selectedOption.label | translate | lowercase }}
              </ng-template>
              <ng-template #item let-option>
                {{ option.label | translate | lowercase }}
              </ng-template>
            </p-select>
          </ng-container>
          <phar-validators [control]="form.get('unit')"
            [errors]="[{ type: 'required', message: 'STUDY.EVENTS.NOTIFICATIONS.ERRORS.UNIT_REQUIRED' }]" />
        </phar-form-field>
      </div>
    </div>
    }

    <phar-form-field label="STUDY.EVENTS.NOTIFICATIONS.SEND_TIME" [isRequired]="true">
      <ng-container inputField>
        <phar-dropdown-timepicker2 formControlName="sendTime"
          [placeholder]="'STUDY.EVENTS.NOTIFICATIONS.SEND_TIME_PLACEHOLDER' | translate" />
      </ng-container>

      <phar-validators validators [control]="form.get('sendTime')"
        [errors]="[{ type: 'required', message: 'STUDY.EVENTS.NOTIFICATIONS.ERRORS.SEND_TIME_REQUIRED' }]" />
    </phar-form-field>
  </form>

  @if (!draftMode()) {
  <div class="d-flex justify-content-between">
    <p-button severity="secondary" variant="outlined" class="btn-small" icon="pi pi-times" [disabled]="!hasPendingChanges()"
      [label]="'COMMON.DISCARD' | translate" (onClick)="discardChanges()" />
      
    <p-button severity="success" class="btn-small" icon="pi pi-check" [disabled]="!hasPendingChanges()"
      [label]="'COMMON.SAVE' | translate" (onClick)="saveNotification()" />
  </div>
  }
  }
</div>